// @core/api/endpoints/tenant/request_tenant_migration.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RequestTenantMigrationRequest,
  TenantMigrationResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Request tenant migration
 * Initiates a migration request to move the tenant to another platform instance. Requires owner privileges. The migration must be approved by platform admins on both sides.
 */
export async function RequestTenantMigration(
  tenant_id: string,
  data: RequestTenantMigrationRequest,
  options?: RequestOptions
): Promise<TenantMigrationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/migration`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.post<TenantMigrationResponse>(requestPath, data, requestOptions);
}
